// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"e2adc1ae","787":"da6fefbc"}[chunkId] + ".chunk.js";
};